.navMenuFullBleed {
    position: sticky;
    top: 0;
    // set to 11 with main nav's value of 10 in mind
    z-index: 11;
}

.navItems {
    overflow-x: auto;
    overscroll-behavior-x: contain;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
}

.navItemList {
    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    justify-content: center;
    gap: var(--spacer-40);
    width: max-content;
    min-width: 100%;
    height: var(--overlappable-nav-height);
    padding-inline: var(--spacer-24);
}
